import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { PageExpressiveLoading } from '@/components/feedback';
import { WalkInWizard } from '@/features/walk-in/components/WalkInWizard';
import { getCustomerById } from '@/features/customers/api';
import type { WalkInCustomer } from '@/features/walk-in/types';

const searchSchema = z.object({
  customerId: z.string().optional(),
});

export const Route = createFileRoute('/_layout/applications/new')({
  component: WalkInPage,
  validateSearch: searchSchema,
});

function WalkInPage() {
  const { customerId } = Route.useSearch();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['customer', customerId],
    queryFn: () => getCustomerById(customerId!),
    enabled: !!customerId,
  });

  if (customerId && isLoading) {
    return <PageExpressiveLoading text="Loading customer..." />;
  }

  // If the customer fetch fails, fall through to the standard wizard so the
  // user can still proceed by searching manually rather than getting stuck.
  const initialCustomer: WalkInCustomer | null =
    customerId && !isError && data?.value
      ? {
          id: data.value.id,
          firstName: data.value.firstName,
          lastName: data.value.lastName,
          phoneNumber: data.value.phoneNumber,
          email: data.value.email,
          nationalId: data.value.nationalId,
          kycStatus: data.value.kycStatus,
          creditTier: data.value.creditTier,
          scoringStatus: data.value.scoringStatus ?? null,
        }
      : null;

  return (
    <div className="p-4 lg:p-6 max-w-6xl mx-auto">
      <WalkInWizard initialCustomer={initialCustomer} />
    </div>
  );
}
